import { render, staticRenderFns } from "./categoryManage.vue?vue&type=template&id=1d60e510&scoped=true"
import script from "./categoryManage.vue?vue&type=script&lang=js"
export * from "./categoryManage.vue?vue&type=script&lang=js"
import style0 from "./categoryManage.vue?vue&type=style&index=0&id=1d60e510&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d60e510",
  null
  
)

export default component.exports